import { notificationApi } from "#/api/notificationApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";

/** Query keys every notification view reads; all of them go stale together. */
export const NOTIFICATION_QUERY_KEYS = {
  unreadCount: ["notification-unread-count"],
  recent: ["notification-recent"],
  all: ["notifications-all"],
} as const;

/**
 * The two write actions on notifications, shared by the bell popover and the
 * full drawer. Each one invalidates the unread count and both lists so the red
 * bubble and the lists update at once instead of waiting for the next poll.
 */
export const useNotificationActions = () => {
  const queryClient = useQueryClient();

  const invalidateAll = async () => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: NOTIFICATION_QUERY_KEYS.unreadCount }),
      queryClient.invalidateQueries({ queryKey: NOTIFICATION_QUERY_KEYS.recent }),
      queryClient.invalidateQueries({ queryKey: NOTIFICATION_QUERY_KEYS.all }),
    ]);
  };

  const markAsRead = useMutation({
    mutationFn: async (id: number) => (await notificationApi.markAsRead(id)).data,
    onSuccess: invalidateAll,
  });

  const markAllAsRead = useMutation({
    mutationFn: async () => (await notificationApi.markAllAsRead()).data,
    onSuccess: invalidateAll,
  });

  return { markAsRead, markAllAsRead };
};
